"use strict";

var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = __importDefault(require("react"));

var react_native_1 = require("react-native");

var react_native_2 = require("react-native");

var theme_1 = require("../../../theming/theme");

var PricingRuleSelector = function (_super) {
  __extends(PricingRuleSelector, _super);

  function PricingRuleSelector() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.renderPricingRuleSelectorItems = function () {
      return _this.props.pricingRulesList.map(function (rule) {
        return react_1.default.createElement(react_native_2.Picker.Item, {
          label: rule.ruleName,
          value: rule.id,
          key: rule.id
        });
      });
    };

    _this.handleOnPricingRuleChange = function (id) {
      _this.props.onChangePricingRule(id);
    };

    return _this;
  }

  PricingRuleSelector.prototype.render = function () {
    return react_1.default.createElement(react_native_1.View, {
      style: styles.pickerView
    }, react_1.default.createElement(react_native_1.Text, {
      style: styles.titleText
    }, "Pricing Rule"), react_1.default.createElement(react_native_2.Picker, {
      enabled: this.props.pricingRulesList.length ? true : false,
      selectedValue: undefined,
      style: styles.pricingRuleSelector,
      onValueChange: this.handleOnPricingRuleChange
    }, this.renderPricingRuleSelectorItems()));
  };

  return PricingRuleSelector;
}(react_1.default.Component);

exports.PricingRuleSelector = PricingRuleSelector;
var pricingRuleNameText = {
  fontSize: 48,
  fontStyle: 'italic',
  fontWeight: '800'
};
var pricingRuleSelector = {
  backgroundColor: theme_1.GreyScale.lightest,
  borderColor: theme_1.PurpleScale.darkest,
  borderRadius: 0,
  borderWidth: 4,
  height: 50,
  padding: 10
};
var titleText = {
  color: theme_1.PurpleScale.darker,
  fontSize: 36,
  fontWeight: '100',
  margin: 10
};
var pickerView = {
  flex: 1,
  minWidth: 500,
  paddingHorizontal: 5
};
var styles = react_native_1.StyleSheet.create({
  pickerView: pickerView,
  pricingRuleNameText: pricingRuleNameText,
  pricingRuleSelector: pricingRuleSelector,
  titleText: titleText
});